<h2 mat-dialog-title>
  {{ (isEdit ? 'waters.price-lists.edit-title' : 'waters.price-lists.add-title') | translate }}
</h2>
<mat-dialog-content>
  <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">{{ 'waters.price-lists.dialog-hint' | translate }}</p>
  <form [formGroup]="form" class="flex flex-col gap-4 pt-2">
    <mat-form-field>
      <mat-label>{{ 'waters.price-lists.field.name' | translate }}</mat-label>
      <input matInput formControlName="name" maxlength="255" />
      <mat-hint>{{ 'waters.price-lists.field.name-hint' | translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'waters.price-lists.field.start-date' | translate }}</mat-label>
      <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" />
      <mat-datepicker-toggle matIconSuffix [for]="startDatePicker" />
      <mat-datepicker #startDatePicker />
      <mat-hint>{{ 'waters.price-lists.field.start-date-hint' | translate }}</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">{{ 'waters.form.cancel' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="save()">
    {{ 'waters.form.save' | translate }}
  </button>
</mat-dialog-actions>
